import { styled } from "styled-components";
import { colors } from "../../../theme/colors";
import { MdChevronLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export const BackButton = ({ title }: { title?: string }) => {
  const navigate = useNavigate();

  return (
    <>
      <BackButtonContainer
        onClick={() => {
          if (window.history.length > 1) {
            navigate(-1);
          } else {
            navigate("/");
          }
        }}
      >
        <MdChevronLeft size={25} color={colors.text.hex} />
      </BackButtonContainer>
      <Title>{title}</Title>
    </>
  );
};

const BackButtonContainer = styled.div`
  position: absolute;
  top: 2rem;
  left: 2rem;
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.textReverse.withOpacity(0.5).hex};
  cursor: pointer;
  z-index: 3;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  color: ${colors.text.hex};
  position: absolute;
  top: 2rem;
  right: 3.25rem;
`;
